module.exports = __webpack_public_path__ + "static/media/channel.9d589e23.svg";